module.exports = __webpack_public_path__ + "54bed334f6488699752d9a940ae382eb.jpg";